/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED --------------- ++++++++++ */
export default theme => ({
	embed: {
		width: '100%',
    fontFamily: 'Verdana',
		height: pxToEm(350),
		color: theme.color.light.light.swatch,
		padding: replacePXinStringWithEM(`0 20px`),
		position: 'relative'
	}
});
